<template>
    <div class="checkoutBlock">
        <h4 class="modal-title">Pickup Location</h4>
        <form class="row" v-if="typeof (shippingAddress) != 'undefined'">
            <!--div class="deliveryMethod col-12 col-xs-12">
                {{shipmentMethod}}
            </div-->
            <div class="form-group col-4 col-xs-4 col-md-2">
                <label for="dCity">Time</label>
                <div id="dCity" class="value">{{cdPickupTime}}</div>
            </div>
            <div class="form-group col-8 col-xs-8 col-md-6 ">
                <label for="dStreet">Pick up address</label>
                <div id="dStreet" class="value">
                    {{shippingAddress.street}}
                </div>
            </div>
            <div class="form-group col-12 col-xs-12 col-md-4 edit">
                <a :disabled="inProgress" href="#" class="btn " @click="change">Change</a>
            </div>
            <div class="form-group col-12 col-xs-12">
                <label for="oNote">Special dietary requirements</label>
                <input v-model="cdNotes" id="oNote" class="form-control"  >
            </div>
        </form>

        <div class="progressor"></div>

        <h4>Customer</h4>
        <form class="row">
            <div class="form-group col-12 col-xs-12 col-md-6">
                <label for="cfName">First name</label>
                <input v-model="cdFirstName" id="cfName" class="form-control" required >
            </div>
            <div class="form-group col-12 col-xs-12 col-md-6">
                <label for="clName">Last name*</label>
                <input v-model="cdLastName" id="clName" class="form-control" required >
            </div>
            <div class="form-group col-12 col-xs-12 col-md-6">
                <label for="cphone">Telephone*</label>
                <input v-model="cdPhone" id="cphone" class="form-control" required >
            </div>
            <div class="form-group col-12 col-xs-12 col-md-6">
                <label for="cEmail">Email*</label>
                <input v-model="cdEmail" id="cEmail" class="form-control"  >
            </div>
        </form>
    </div>
</template>
<script>

    export default {
        name: 'ConfirmDelivery',
        props: {
        },
        components: {
//            VueBootstrapTypeahead
        },
        mounted() {
        },
        methods: {
            change() {
                this.$store.dispatch('requestAddress',true)
                return false;
            },
        },

        computed: {
            shippingAddress() {
                return  this.$store.state.cart.shippingAddress
            },
            shipmentMethod() {
                if (this.$store.state.cart.shipments.length
                && (this.$store.state.cart.checkoutState=='payment_selected' || this.$store.state.cart.checkoutState=='shipping_selected')) {
                    return  this.$store.state.cart.shipments[0].method.name
                } else {
                    return 'Delivery option is not available'
                }
            },
            cdPickupTime: {
                get() {
                    return  this.$store.state.completeData.pickup
                },
                set(val) {
                    let a = this.$store.state.completeData
                    a.pickup = val
                    this.$store.commit('changeCompleteData', a)
                }
            },
            cdFirstName: {
                get() {
                    return  this.$store.state.completeData.firstName
                },
                set(val) {
                    let a = this.$store.state.completeData
                    a.firstName = val
                    this.$store.commit('changeCompleteData', a)
                }
            },
            cdLastName: {
                get() {
                    return  this.$store.state.completeData.lastName
                },
                set(val) {
                    let a = this.$store.state.completeData
                    a.lastName = val
                    this.$store.commit('changeCompleteData', a)
                }
            },
            cdEmail: {
                get() {
                    return  this.$store.state.completeData.email
                },
                set(val) {
                    let a = this.$store.state.completeData
                    a.email = val
                    this.$store.commit('changeCompleteData', a)
                }
            },
            cdPhone: {
                get() {
                    return  this.$store.state.completeData.phoneNumber
                },
                set(val) {
                    let a = this.$store.state.completeData
                    a.phoneNumber = val
                    this.$store.commit('changeCompleteData', a)
                }
            },
            cdNotes: {
                get() {
                    return  this.$store.state.completeData.notes
                },
                set(val) {
                    let a = this.$store.state.completeData
                    a.notes = val
                    this.$store.commit('changeCompleteData', a)
                }
            },
            inProgress () {
                return this.$store.state.inProgress
            },
        },
    }

</script>